module.exports.about = {
  vi: {
    title: 'Avalon: The Resistance | Giới thiệu',
    description:
      'Khám phá avalon-game.com, nền tảng dành cho The Resistance: Avalon. Tìm hiểu câu chuyện về trò chơi, luật chơi chính thức và cách chúng tôi kết nối người yêu Avalon trên toàn thế giới.',
    keywords: ['Giới thiệu', 'Thông tin', 'Luật chơi'],
  },
  pt: {
    title: 'Avalon: The Resistance | Sobre',
    description:
      "Mergulhe no avalon-game.com: uma plataforma abrangente dedicada a 'Avalon: The Resistance'. Descubra a história por trás do jogo, suas regras oficiais e como reunimos entusiastas de Avalon em todo o mundo.",
    keywords: ['Sobre', 'Informação', 'Regras'],
  },
  en: {
    title: 'Avalon: The Resistance | About',
    description:
      "Dive into avalon-game.com: a comprehensive platform dedicated to 'Avalon: The Resistance'. Discover the story behind the game, its official rules, and how we bring together Avalon enthusiasts worldwide.",
    keywords: ['About', 'Information', 'Rules'],
  },
  ru: {
    title: 'Авалон: Сопротивление | О сайте',
    description:
      "Погрузитесь в avalon-game.com: это комплексная платформа, посвященная 'Авалон: Сопротивление'. Узнайте о нашем сайте, его функциях и том, как мы объединяем любителей Авалона по всему миру.",
    keywords: ['О сайте', 'Информация', 'Правила'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 關於我們',
    description:
      '探索 avalon-game.com：這是一個專為「阿瓦隆：反抗勢力」打造的綜合平台。了解我們的網站、其功能，以及我們如何將全球的阿瓦隆愛好者聚集在一起。',
    keywords: ['關於我們', '信息', '規則'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 关于我们',
    description:
      '探索 avalon-game.com：这是一个专注于“阿瓦隆：反抗组织”的综合平台。了解我们的网站、其功能，以及我们如何聚集全球的阿瓦隆爱好者。',
    keywords: ['关于我们', '信息', '规则'],
  },
  es: {
    title: 'Avalon: La Resistencia | Sobre nosotros',
    description:
      "Sumérgete en avalon-game.com: una plataforma integral dedicada a 'Avalon: La Resistencia'. Descubre la historia detrás del juego, sus reglas oficiales y cómo reunimos a entusiastas de Avalon en todo el mundo.",
    keywords: ['Sobre nosotros', 'Información', 'Reglas'],
  },
};
